<script>
    //  const BASE_URL = 'http://127.0.0.1:3000/';
    const BASE_URL = 'https://store.thingjs.com/api/';
    const MMD_URL = "http://www.3dmomoda.com:80/";
     // 检测mmdid是否合法
    function AntiSqlValid(oField) {
        oField = oField || '';
        oField = oField.toString();
        const re = /select|update|delete|exec|count|'|"|=|;|>|<|%/i;
        if (re.test(oField)) {
            //alert("请您不要在参数中输入特殊字符和SQL关键字！"); //注意中文乱码
            return false;
        }
        return true;
    }
    export default{
        BASE_URL,
        MMD_URL,
        AntiSqlValid
    }
</script>



// WEBPACK FOOTER //
// src/Global.vue